import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";
  
  export default function ConfirmationDialog({
    open,
    title = "Please, confirm action",
    message = "Do you really like to take action?",
    confirmText = "Yes",
    cancelText = "No",
    onConfirm,
    onClose,
    loading = false,
  }) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>{title}</DialogTitle>
  
        <DialogContent>
          <Typography>{message}</Typography>
        </DialogContent>
  
        <DialogActions>
          <Button
            onClick={onClose}
            color="error"
            variant="contained"
            disabled={loading}
          >
            {cancelText}
          </Button>
  
          <Button
            onClick={onConfirm}
            disabled={loading}
          >
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  